import React, { useEffect, useState } from 'react'
import { useTranslation } from '../../../locale/useTranslation';
import { GOOGLE_ADVERTISING_CHANNEL_TYPE } from '../SocialMediaConstant';
import { DropDownList } from '@progress/kendo-react-dropdowns';

const GoogleCampaignForm = ({ dataItem, setDataItem }) => {

    const lang = useTranslation();
    const [advertisingChannelTypes, setAdvertisingChannelTypes] = useState([]);
    
    useEffect(() => {
        loadCombo();
    }, []);
    
    const loadCombo = async () => {
        let advertisingChannelTypeRes = Object.keys(GOOGLE_ADVERTISING_CHANNEL_TYPE).map(key => ({
            _id: GOOGLE_ADVERTISING_CHANNEL_TYPE[key],
            description: key
        }));
        setAdvertisingChannelTypes(advertisingChannelTypeRes);
    }

    const onChange = (e) => {
        const { name, value } = e.target;
        setDataItem({ ...dataItem, [name]: value });
    };

    return (
        <div className="row p-2">
            <div className="col-6">
                <label htmlFor="advertiadvertising_channel_typesingChannelType" className="form-label">{lang.advertising_channel_type_lable} *</label>
                <DropDownList
                    name="advertising_channel_type"
                    textField="description"
                    dataItemKey="_id"
                    data={advertisingChannelTypes}
                    value={dataItem.advertising_channel_type}
                    onChange={onChange}
                />
            </div>
            <div className="col-6">
                <label htmlFor="cpc_bid_micros" className="form-label">{lang.spand_cap_label} *</label>
                <input
                    type="text"
                    name="cpc_bid_micros"
                    className='form-control form-control-sm'
                    placeholder="Enter Spand Cap"
                    value={dataItem.cpc_bid_micros}
                    onChange={onChange}
                />
            </div>
        </div>

    )
}

export default GoogleCampaignForm